module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid60_1080x850.eb8e714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid60_1080x850.jpg
// module id = P/pq
// module chunks = 0